/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */

export type PlaceOrderDtoTimeInForce = (typeof PlaceOrderDtoTimeInForce)[keyof typeof PlaceOrderDtoTimeInForce];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PlaceOrderDtoTimeInForce = {
  gtc: 'gtc',
  day: 'day',
  fok: 'fok',
  ioc: 'ioc',
} as const;
